import {translations} from "../config/translations.ts";

export function getWhatsAppUrl(whatsappNumber: string | undefined): string {
    const encodedText = encodeURIComponent(translations.WHATSAPP_MESSAGE);
    return `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodedText}`;
}

